// extracted by mini-css-extract-plugin
export default {"container":"DraggableSidebarField_container__+lbUd"};